import Api from "./Api";
import { createQueryString } from "./ApiHelper";
export default {
  getSignageServices(payload) {
    return Api().get(`/signage/${payload}`);
    //return Api().get(`/signage/${payload.id}`)
  },
  getNextChangeService(payload) {
    return Api().get(`/nextchange/${payload.cinema_id}/${payload.screen_id}`);
  },
  getSchedule(payload) {
    return Api().get("/schedule");
  },
  getNowShowing(payload) {
    return Api().get(`/nowshowing/${payload.cinema_id}/${payload.screen_id}`);
  },
  getComingSoon(payload) {
    return Api().get(`/commingsoon/${payload.cinema_id}`);
  },
  getLatestRelease(payload) {
    console.log("payload :", payload);
    return Api().get(`/latestrelease/${payload}`);
  },
  addSignageUrl(payload) {
    return Api().post("/addsignageurl", payload);
  },
  getDynamicSignage(payload) {
    console.log("payload :", payload);
    return Api().get(`/getDynamicSignage/${payload}`, payload);
  },
  viewSignageUrlDetails(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage") &&
      payload.hasOwnProperty("columnName")
    ) {
      return Api().post(
        `/viewsignageurl?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`,
        payload
      );
    }
    return Api().post("/viewsignageurl", payload);
  },
  getSingleSignageUrlDetails(payload) {
    return Api().get(`/getsinglesignageurl/${payload.su_id}`);
  },

  //Signage Movie Mapping
  GetMovieDetails() {
    return Api().get(`/getmoviedetails`);
  },
  AddSignageMovieMapping(payload) {
    return Api().post(`/signagemoviemapping`, payload);
  },
  GetSignageMovieMapping(payload) {
    if (payload && payload.hasOwnProperty("st_id")) {
      return Api().get(`/signagemoviemapping?st_id=${payload.st_id}`);
    } else {
      return Api().get(
        `/signagemoviemapping?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}`
      );
    }
  },
  UpdateSignageMovieMapping(payload) {
    return Api().put(`/signagemoviemapping`, payload);
  },
  GetFnBListSignages(payload) {
    return Api(payload).post("/api/admin/getfnbitems", payload);
  },
  UpdateSignageUrl(payload) {
    return Api().put(`/api/admin/signage_url/${payload.su_id}`, payload);
  },

  AddDisplaySignageUrl(payload) {
    return Api().post(`/api/signage/add-display-signage`, payload);
  },
  getDisplaySignage(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/signage/get-signage-display-list${query}`);
  },
  UpdateSignageStatus(payload) {
    // const query = createQueryString(payload);
    return Api().post(
      `/api/signage/signage-status/${payload.display_id}`,
      payload
    );
  },
  getPaymentCredential(payload) {
    return Api().post(`/api/cinema/alrajhi/payment-credential`, payload);
  },
  updatePaymentCredential(payload) {
    return Api().post(`/api/cinema/alrajhi/update-payment-credential`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/signageService.js